<template>
  <div class="question-block">
    <g-title tag="h1" size="m">{{ blockData.Title }}</g-title>
    <g-markdown :content="blockData.Intro" />
    <template v-for="(question, index) in localQuestions">
      <g-markdown
        v-if="question.__component === 'standard-components.rich-text'"
        :key="`md:${index}`"
        :content="question.text"
      />
      <TextInput
        v-if="question.__component === 'standard-components.text-input'"
        :key="`ti:${index}`"
        :label="question.Label"
        :description="question.Description"
        :long-text="question.LongText"
        :visible="hiddenQuestions[question.Key]"
        @change="value => handleChange(question.Key, value)"
      />
      <RadioGroup
        v-else-if="question.__component === 'standard-components.radio-group'"
        :key="`rg:${index}`"
        :label="question.Label"
        :wide="question.Wide"
        :multiple="question.Multiple"
        :choices="question.RadioChoices"
        :other="question.Other"
        :other-label="question.OtherLabel"
        :description="question.Description"
        :visible="hiddenQuestions[question.Entity]"
        @change="value => handleChange(question.Entity, value)"
      />
      <Slider
        v-else-if="question.__component === 'standard-components.slider'"
        :key="`s:${index}`"
        :label="question.Label"
        :description="question.Description"
        :display-min="question.MinLabel"
        :display-max="question.MaxLabel"
        :show-emojis="question.ShowEmojis"
        :visible="hiddenQuestions[question.Entity]"
        :start-percentage="question.StartPercentage"
        @change="value => handleChange(question.Entity, value)"
      />
    </template>
    <g-button @click="next">Spara & gå vidare</g-button>
  </div>
</template>

<script>
import Vue from 'vue';
import UPDATE_STATISTIC from '@/graphql/story/UpdateStatistic.gql';
import config from '@/services/config.js';

import Globals from '@/mixins/Globals';
import RadioGroup from '@/components/RadioGroup';
import TextInput from '@/components/TextInput';
import Slider from '@/components/Slider';

import { DateTime } from 'luxon';

export default {
  components: {
    TextInput,
    RadioGroup,
    Slider
  },
  mixins: [Globals],
  props: {
    blockData: {
      type: Object,
      default: () => {}
    }
  },
  data() {
    return {
      data: {},
      localQuestions: [...this.blockData.Questions],
      hiddenQuestions: {},
      visibleQuestionGroup: false
    };
  },
  created() {
    this.localQuestions.forEach(question => {
      if (question.DependsOnEntity && question.DependsOnEntity.length) {
        if (question.__component !== 'standard-components.text-input') {
          this.hiddenQuestions[question.Entity] = false;
        } else {
          this.hiddenQuestions[question.Key] = false;
        }
      } else {
        if (question.__component !== 'standard-components.text-input') {
          this.hiddenQuestions[question.Entity] = true;
        } else {
          this.hiddenQuestions[question.Key] = true;
        }
      }
    });

    // take care of global dependencies
    const sessionItem = window.sessionStorage.getItem('userObject');
    if (!sessionItem) return;
    let userObject = JSON.parse(sessionItem);
    let formData = userObject['formData'];

    this.localQuestions.forEach(question => {
      if (
        question.DependsOnEntity &&
        question.DependsOnEntity.length &&
        Object.keys(formData).includes(question.DependsOnEntity)
      ) {
        const formValueArray = formData[question.DependsOnEntity].split(',');

        let showQuestion = false;

        for (let i = 0; i < formValueArray.length; i++) {
          const dependencyValueArray = question.DependsOnEntityValue.split('|');

          for (let j = 0; j < dependencyValueArray.length; j++) {
            if (formValueArray[i] == dependencyValueArray[j]) {
              showQuestion = true;
              break;
            }
          }
        }
        if (showQuestion) {
          if (question.__component !== 'standard-components.text-input') {
            this.hiddenQuestions[question.Entity] = true;
          } else {
            this.hiddenQuestions[question.Key] = true;
          }
        }
      }
    });
  },
  methods: {
    handleChange(key, value) {
      if (typeof value === 'object') {
        value = Object.values(value).join(',');
      }

      this.data[key] = value;

      this.localQuestions.forEach(question => {
        if (
          question.DependsOnEntity &&
          question.DependsOnEntity.length &&
          question.DependsOnEntity === key
        ) {
          let localObj = { ...this.hiddenQuestions };
          if (question.DependsOnEntityValue.indexOf(value) !== -1) {
            if (question.__component !== 'standard-components.text-input') {
              localObj[question.Entity] = true;
            } else {
              localObj[question.Key] = true;
            }
          } else {
            if (question.__component !== 'standard-components.text-input') {
              localObj[question.Entity] = false;
              delete this.data[question.Entity];
            } else {
              localObj[question.Key] = false;
              delete this.data[question.Key];
            }
          }

          Vue.set(this, 'hiddenQuestions', localObj);
        }
      });
    },
    async next() {
      // Save data
      await this.saveData();

      // ChatDates
      let chatIsActive = false;
      const currentDateTime = DateTime.local();
      currentDateTime.setZone('europe/Stockholm');

      for (let index in this.blockData.ChatDates) {
        const chatDate = this.blockData.ChatDates[index];
        const startDateTime = DateTime.fromISO(chatDate.StartDate, {
          zone: 'europe/Stockholm'
        });
        const endDateTime = DateTime.fromISO(chatDate.EndDate, {
          zone: 'europe/Stockholm'
        });

        if (
          currentDateTime >= startDateTime &&
          currentDateTime <= endDateTime
        ) {
          chatIsActive = true;
          break;
        }
      }

      const nextRoute = this.getNextRoute();
      //console.log('nextRoute', nextRoute);
      this.$router.push(nextRoute);

      /*       if (chatIsActive) {
        let chatStatus = null;
        try {
          chatStatus = await window.fetch(config.CHAT_URL);
          chatStatus = await chatStatus.json();
        } catch (e) {
          await this.$router.push({ name: 'question-blocks' });
        }

        if (chatStatus.status === 'ok') {
          await this.$router.push({
            name: 'chat',
            params: { id: this.blockData.id }
          });
        } else {
          // Go back to the questions
          await this.$router.push({ name: 'question-blocks' });
        }
      } else {
        // Go back to the questions
        await this.$router.push({ name: 'question-blocks' });
      } */
    },
    async saveData() {
      // Parsing the userObject
      const sessionItem = window.sessionStorage.getItem('userObject');
      // Checks if the session item is not set,
      // if so just return
      if (!sessionItem) return;

      let userObject = JSON.parse(sessionItem);

      let questions = userObject['questions'];
      // Checks if there is no question object, if so questions will be set to an empty object
      if (!questions) {
        questions = {};
      }

      // Set the data into the question object with the key as the QuestionBlock id.
      questions[this.blockData.id] = this.data;
      // Set the new question object into the userObject
      userObject['questions'] = questions;

      // Set the updated user object into the sessionStorage again
      window.sessionStorage.setItem('userObject', JSON.stringify(userObject));

      // Check if the statistics_id does not exist, if so it will not continue
      if (!userObject.hasOwnProperty('statistic_id')) return;

      try {
        await this.$apollo.mutate({
          mutation: UPDATE_STATISTIC,
          variables: {
            input: {
              where: {
                id: parseInt(userObject.statistic_id)
              },
              data: {
                Data: userObject
              }
            }
          }
        });
      } catch (e) {
        // TODO: Handle error
      }
    }
  }
};
</script>

<style scoped></style>
